module.exports = __webpack_public_path__ + "img/iphone-map-FRANCE-en.cdb9c493.webp";